import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carla M.',
  role: 'Psicóloga Clínica, 34 años',
  text: 'Llegaba a las sesiones sin tiempo para preparar nada. Con el Mega Pack tengo todo organizado: ejercicios, protocolos e ideas claras. Ahora trabajo con más tranquilidad y mis pacientes lo notan.'
}, {
  name: 'Lucía R.',
  role: 'Terapia Cognitivo-Conductual, 29 años',
  text: 'Las 24 sesiones listas me ahorraron horas cada semana. Por primera vez siento que tengo un sistema real y no estoy improvisando constantemente.'
}, {
  name: 'Sofía P.',
  role: 'Psicóloga de Adultos, 41 años',
  text: 'El Mapa Terapéutico y el Checklist inicial marcaron un antes y un después. Hoy tengo menos carga mental y puedo enfocarme más en cada paciente.'
}, {
  name: 'Ana G.',
  role: 'Psicóloga Infantil, 36 años',
  text: 'Material profesional y adaptable. Lo uso tanto con niños como adolescentes. Me siento más segura en cada sesión.'
}, {
  name: 'María T.',
  role: 'Consulta Privada, 38 años',
  text: 'Invertí en el Mega Pack y recuperé mi tiempo. Ya no llevo trabajo a casa y mis sesiones tienen más estructura. Totalmente recomendado.'
}];
export function TestimonialsSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-196">
          Lo que dicen otras psicólogas
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-198">
              <div className="flex gap-1 mb-4" data-id="element-199">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-200" />)}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic" data-id="element-201">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 border-t border-gray-100 pt-4" data-id="element-202">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-700 font-bold text-sm" data-id="element-203">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-204">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-205">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-206">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}